import Rates from "./Rates";
import { useLocation, useHistory } from "react-router-dom";
import { useCallback, useState, useMemo, useEffect } from "react";
import ReactInterval from "react-interval";
import { isAuthenticated, signOut } from "../../store/action/auth";
import { Button, Tab } from "@biteship/atom";
import Tickets from "../tickets";
import { OVERVIEW_TABS } from "@constants/overview";
import Profile from "../profile";
import Integration from "../integration";
import { getUser, updateUserOnLocal } from "@store/action/user";

export default function Overview(props) {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get("tab") || "tickets";
  const [loading, setLoading] = useState(false);
  const onChangeTab = useCallback(
    (tab) => {
      queryParams.set("tab", tab);
      history.push({ search: queryParams.toString() });
    },
    [tab]
  );
  /** @type {[import("@store/action/user").User, function]} */
  const [user, setUser] = useState(null);
  const fetchUser = useCallback(async () => {
    try {
      const { user, token } = isAuthenticated();
      if (user?.courier) {
        setUser(user);
        return;
      }
      
      const result = await getUser(token);
      if (result.success) {
        updateUserOnLocal(result.data, () => {});
        setUser(result.data);
      } else {
        alert("Gagal mengambil data akun, silahkan refresh halaman");
      }
    } catch (error) {
      alert("Terjadi kesalahan saat mengambil data");
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const tabs = useMemo(() => {
    return OVERVIEW_TABS.filter((tab) => {
      if (tab.value === "integration") {
        // only show integration tab to open couriers
        return user?.courier?.openCourierId;
      }
      return true;
    })
  }, [user]);

  return (
    <div className="p-6 space-y-4">
      <ReactInterval
        timeout={500}
        enabled={loading}
        callback={() =>
          signOut(() => {
            window.location.replace("/");
            setLoading(false);
          })
        }
      />
      <div className="flex justify-between">
        <h4>Halaman Utama</h4>
        <Button
          secondary
          onClick={() => setLoading(true)}
          loading={loading}
          title={loading ? "Signing Out..." : "Sign Out"}
        />
      </div>
      <Tab tabs={tabs} tab={tab} onSelect={onChangeTab} />
      {tab === "tickets" && <Tickets />}
      {tab === "rates" && <Rates />}
      {tab === "profile" && <Profile />}
      {tab === "integration" && <Integration />}
    </div>
  );
}
